const R = require('ramda')

const installDB = require('./db/installClient')
const installView = require('./view/installClient')

module.exports = R.pipe(
  installDB,
  installView,
)
